<div id="content" class="main-content">
    <div class="container">
       <div class="col-12 pl-0">
          <div class="crumbs breadcrumbs-style-2">
             <ul class="breadcrumb">
                <li class="mt-3"><a class="pointer" routerLink="/dashboard"><i class="flaticon-home-fill"></i></a></li>
                <li class="mt-3"><a class="pointer" routerLink="/absence">Absences</a></li>
                <li class="active mt-3 current_arian"><a href="javascript:void(0);" class="current_arian">Détail d'absence</a></li>
             </ul>
          </div>
       </div>
        <div class="row layout-spacing">
        <!-- COLUMN OF FORMULAIRE -->
        <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 layout-spacing">
            <div class="statbox widget box box-shadow">
                <div class="widget-content widget-content-area" style="border-top-right-radius: 6px;
                    border-top-left-radius: 6px;">
                    <div *ngIf="detailLoading" class="cp-spinner cp-bubble" style="position: absolute;z-index: 9;margin: auto;display: block;margin-left: 42%;margin-top: 10%;"></div>
                    <blockquote class="blockquote" >
                        <div class="d-flex justify-content-between mb-3">
                            <h3>Détail d'absence</h3>
                            <img class="border-basic" [src]="leave.avatar ? 'data:image/jpeg;base64,' + leave.avatar : '../../assets/img/unknown_user.jpg'" alt="User Avatar" style="width: 50px; height: 50px; border-radius: 50px;">
                        </div>
                        <div class="row form-group mb-3 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                   <b>Nom complet</b> 
                                </div>
                                <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                    {{leave.fullname}}
                                </div>
                            </div>
                            <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                    <b>Type d'absence </b>
                                </div>
                                <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                    {{leave.type}}
                                </div>
                            </div>
                        </div>
                        <div class="row form-group mb-3 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                    <b>Date de début de l’absence</b> 
                                </div>
                                <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                    {{leave.start}}
                                </div>
                            </div>
                            <div class="row col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                                <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                    <b>Date de fin de l’absence</b> 
                                </div>
                                <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                    {{leave.finish}}
                                </div>
                            </div>
                        </div>
                        <div class="row form-group mb-3 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-4">
                            <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                <b>Motif d'absence</b>
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                                {{leave.reason}}
                            </div>
                        </div>
                        <div *ngIf="leave?.attachmentEnvelops?.length > 0" class="row form-group mb-3 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-5">
                            <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                <b>Pieces jointe</b>
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12 mt-2 listAtt">
                                <table id="alter_pagination" class="table table-striped table-bordered table-hover" style="width:100%">
                                    <thead>
                                        <tr>
                                            <th>Date d'ajout</th>
                                            <th>Nom</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let file of leave?.attachmentEnvelops; let i=index">
                                            <td>{{file.addedAt | date: 'dd/MM/yyyy - HH:mm ' || '----'}}</td>
                                            <td (mouseenter)="showImage(file)" (mouseleave)="hideImage()">
                                               <a style="color: #027476;" href="javascript:void(0)"> piece jointe ({{i+1}}) - {{leave.type}}</a>
                                                <img *ngIf="hoveredFile === file" [src]="file.base64Image" alt="Preview" style="position: absolute; top: 0; left: 50%; max-width: 200px; z-index: 9999;"/>  
                                            </td>                                          
                                            <td>
                                                <a href="javascript:void(0)" (click)="downloadPicture($event, leave, file.file)">
                                                    <i class="fa fa-download"></i> Télécharger
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </blockquote>
                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 layout-spacing">
                        <div class="l-a-load-more pt-2 actions_buttons d-flex justify-content-center">
                            <button type="reset" class="btn progress-button btn-rounded mb-2 pr-5 pl-5 mr-2" style="background-color: #bac5ed;" routerLink="/absence">
                                Retour
                            </button>
                            <a *ngIf="fullname === leave?.fullname"  [attr.href]="'absence-update/' + leave.id" id="loading-circle-notification" class="btn btn-gradient-success btn-rounded mb-2 mr-2 pr-5 pl-5">
                                Modifier
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
 </div>